import { ChevronDownIcon } from "@chakra-ui/icons";
import { Box, Heading } from "@chakra-ui/react";

const GptToggleButton = ({
  title = "Toggle",
  isOpen,
  onToggle,
  leftContent,
  rightIcon = <ChevronDownIcon />,
  ...props
}) => {
  return (
    <Box
      as="button"
      type="button"
      width="100%"
      px={4}
      py={3}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      fontWeight="semibold"
      borderRadius="md"
      bg="gray.50"
      _hover={{ bg: "gray.100" }}
      onClick={onToggle}
      {...props}
    >
      <Box textAlign="left">
        {leftContent ?? <Heading size="xs">{title}</Heading>}
      </Box>

      <Box
        transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
        transition="transform 0.2s ease"
      >
        {rightIcon}
      </Box>
    </Box>
  );
};

export default GptToggleButton;
